import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";

import { ThemeProvider } from "@/components/theme-provider";
import { AuthProvider } from "@/context/AuthContext";
import { MarketingLayout } from "@/components/layout/MarketingLayout";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import PricingPage from "@/pages/Pricing";
import FeaturesPage from "@/pages/Features";
import LoginPage from "@/pages/Login";
import SignupPage from "@/pages/Signup";
import DashboardPage from "@/pages/Dashboard";
import WorkspacePage from "@/pages/Workspace";
import SettingsPage from "@/pages/Settings";
import ToolRedirect from "@/pages/ToolRedirect";
import AuthCallback from "@/pages/AuthCallback";
import NotFoundPage from "@/pages/NotFound";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function useBackendPing() {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/`, { timeout: 5000 });
        if (!cancelled) console.info("[MACHA] backend:", r.data?.message);
      } catch (e) {
        if (!cancelled) console.warn("[MACHA] backend ping failed", e?.message);
      }
    })();
    return () => { cancelled = true; };
  }, []);
}

function AppRoutes() {
  useBackendPing();
  const wrap = (Component) => (
    <MarketingLayout>
      <Component />
    </MarketingLayout>
  );
  return (
    <Routes>
      <Route path="/" element={wrap(Home)} />
      <Route path="/features" element={wrap(FeaturesPage)} />
      <Route path="/pricing" element={wrap(PricingPage)} />
      <Route path="/login" element={wrap(LoginPage)} />
      <Route path="/signup" element={wrap(SignupPage)} />
      <Route path="/dashboard" element={wrap(DashboardPage)} />
      <Route path="/settings" element={wrap(SettingsPage)} />
      {/* ReplyAssistant renders its own layout (sticky output panel + modal). */}
      {/* Conversational AI workspace — flagship surface */}
      <Route path="/workspace" element={<WorkspacePage />} />
      {/* Legacy tool routes redirect into the workspace with the right tool selected */}
      <Route path="/tools/reply-assistant" element={<ToolRedirect />} />
      <Route path="/tools/proposal-generator" element={<ToolRedirect />} />
      <Route path="/tools/client-analyzer" element={<ToolRedirect />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="*" element={wrap(NotFoundPage)} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}
